import { StateCreator } from "zustand";
import { MonthlyHeadquarterSummary } from "../../../domain/models/coverage-reports/monthly-headquarter-summary";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import {
  AUTH_HEADER,
  SECURE_AUTH_TOKEN_KEY,
  SECURE_BASE_URL_KEY
} from "../../../base";
import { FetchMonthlyHeadquarterSummary } from "../../../domain/useages/coverage-reports/fetch-monthly-headquarter-summary";
import { RemoteFetchMonthlyHeadquarterSummary } from "../../../data/usecases/coverage-reports/remote-fetch-monthly-headquarter-summary";
import Endpoints from "../../../domain/endpoints";
import dayjs, { Dayjs } from "dayjs";
import moment from "moment";
import { FetchState } from "../../../domain/models/fetch-state";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";

export interface FetchMonthlyHeaduqarterSummaryInterface {
  monthlyHeadquarterSummaryData: MonthlyHeadquarterSummary[];
  fetchMonthlyHeadquarterSummary: Function;
  monthlyHeadquarterSummaryDataLoading: FetchState;
  monthlyHeadquarterFilters: {
    monthYear: Dayjs | null;
  };
}

const initialStates = {
  monthlyHeadquarterSummaryData: [],
  monthlyHeadquarterSummaryDataLoading: FetchState.DEFAULT,
  monthlyHeadquarterFilters: { monthYear: dayjs(new Date()) },
};

const axiosHttpClient = AxiosHttpClient.getInstance();


export const useFetchMonthlyHeadquarterSummarySlice: StateCreator<
  FetchMonthlyHeaduqarterSummaryInterface
> = (set, get) => ({
  ...initialStates,
  fetchMonthlyHeadquarterSummary: async () => {
    const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
    const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    let filterParams = {
      month_year: moment(
        (get().monthlyHeadquarterFilters.monthYear as Dayjs).toString()
      ).format("YYYYMM"),
      visitor_role: "HQ_MNG",
    };

    const remoteFetchMonthlyHeadquarterSummary: FetchMonthlyHeadquarterSummary =
      new RemoteFetchMonthlyHeadquarterSummary(
        `${BASE_URL}${Endpoints.FETCH_MONTHLY_HEADQUARTER_SUMMARY}`,
        axiosHttpClient
      );

    set(() => ({ monthlyHeadquarterSummaryDataLoading: FetchState.LOADING }));

    let result = await remoteFetchMonthlyHeadquarterSummary.fetch(filterParams);
    if (result) {
      set(() => ({
        monthlyHeadquarterSummaryData: result,
        monthlyHeadquarterSummaryDataLoading: FetchState.SUCCESS,
      }));
    }
  },
});
